import { IotError } from "@iot-platform/core";
import { t } from "i18next";

export class InvalidCredentialsError extends IotError {
    constructor() {
        super(t("error:authentication.login.invalidCredentialsMessage"));

        Object.setPrototypeOf(this, InvalidCredentialsError.prototype);
    }
}
